angular.module('callX').controller('LoginCtrl', ['$scope', 'UserService', '$state', 'toaster','$rootScope', function($scope, UserService, $state, toaster,$rootScope) {

    var baseUrl = window.location.origin;
    var newAppSignInPath = baseUrl+'/v2/sign-in';  
    if (!baseUrl.includes('localhost')) {
        window.location.href = newAppSignInPath;
    }

    $scope.user = {};
    $scope.showLoaderOnLogInClick = false;

    if ($rootScope.socket && ($rootScope.socket.readyState != 2 || $rootScope.socket.readyState != 3)) {
        $rootScope.socket.close()
    }
    if($rootScope.plivoWebSdk && $rootScope.plivoWebSdk.client.isLoggedIn) {
        $rootScope.plivoWebSdk.client.logout();
    }
    // $scope.notifyMeLogin = function(fullName,msg) {
    //     if (!("Notification" in window)) {
    //     alert("This browser does not support desktop notification");
    //     }
    //     else if (Notification.permission === "granted") {
    //         var options = {
    //                 body: msg,
    //                 icon: "img/callx-brand-black-logo.svg",
    //                 dir : "ltr"
    //              };
    //           var notification = new Notification(fullName,options);
    //     }
    //     else if (Notification.permission !== 'denied') {
    //     Notification.requestPermission(function (permission) {
    //       if (!('permission' in Notification)) {
    //         Notification.permission = permission;
    //       }

    //       if (permission === "granted") {
    //         var options = {
    //               body: msg,
    //               icon: "img/callx-brand-black-logo.svg",
    //               dir : "ltr"
    //           };
    //         var notification = new Notification(fullName,options);
    //       }
    //     });
    //     }
    //     }

    $scope.login = function() {
        $scope.showLoaderOnLogInClick = true;
        if ($scope.user.email == undefined) {
            $scope.showLoaderOnLogInClick = false;
            toaster.pop('error', 'Email',  'Email is required.', 2000);
        }

        else if ($scope.user.password == undefined) {
            $scope.showLoaderOnLogInClick = false;
            toaster.pop('error', 'Password', 'Password is required', 2000);
        }

        if ($scope.user.email != undefined && $scope.user.password != undefined) {

            var callbacks = {
                success: function (data, status) {
                    $scope.showLoaderOnLogInClick = false;
                    SentryUtils.removeFeedbackWidget();

                    // if (data && data.userId) {
                    //     var logMessage = "Event: User Login Click | Agent Id: " + data.userId + " | Date: " + new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false });
                    //     Sentry.captureMessage(logMessage, {
                    //       level: "log",
                    //       fingerprint: ["unique-event-" + Date.now()]
                    //     });
                    // }
                //     $scope.socketData = {};
                //     var socket = new SockJS("/japi/stomp");
                //     var stompClient = Stomp.over(socket);
                //     stompClient.connect({ }, function(frame) {
                //     stompClient.subscribe("/topic/message", function(data) {
                //     $scope.socketData = data.data;
                //      data.body = JSON.parse(data.body);
                //      $scope.fullName = data.body.data.sms_dtos[0].first_name+" "+data.body.data.sms_dtos[0].last_name+" "+"says...";
                //      $scope.currentStateName = $state.current.name;
                //      if(data.body.data.sms_dtos[0].type == 'receive' && $scope.currentStateName != 'app.chats.chats-by-campaign'){
                //      $scope.notifyMeLogin($scope.fullName, data.body.data.sms_dtos[0].message)
                //         }
                //     });
                // });

                //wrong credentials check - start
                    if(status != 200){
                      toaster.pop('error', 'Error', data.status, 2000);   
                    }
                //wrong credentials check - end
                },
                failure: function (data) {
                    $scope.showLoaderOnLogInClick = false;
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.login($scope.user, callbacks);
        }
    };

    $scope.togglePassword = function () { $scope.typePassword = !$scope.typePassword; };

  }])
;